import classnames from 'classnames';
import { memo, useMemo } from 'react';

const fontSize = 12;

const Username = ({ name = '' }: { name: string }) => {
  const width = useMemo(() => calcWidth(name, fontSize), [name]);

  return (
    <section className="user-name flex max-w-[25vw] overflow-hidden">
      <div
        className={classnames(
          'm-0 inline-block overflow-hidden text-ellipsis whitespace-nowrap align-bottom text-black dark:text-white'
        )}
        style={{
          maxWidth: width || 0,
          transition: 'max-width 0.15s ease-out 0.5s',
          willChange: 'max-width',
          fontSize,
        }}
      >
        <span>{name}</span>
      </div>
    </section>
  );
};

export default memo(Username, (prev, next) => prev.name === next.name);

function calcWidth(content = '', fontSize = 0) {
  const widthFactor = 0.6; // Adjust this factor based on your specific requirements
  return fontSize * widthFactor * content.length;
}
